import { combineEpics } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { FetchProfileActionTypes } from '../actions/ProfileActions';
import { FetchNotificationsActionTypes } from '../actions/NotificationActions';
import { createUnrecoverableError } from '../actions/UnrecoverableErrorActions';
const unrecoverableErrorActionTypes = [FetchProfileActionTypes.FAILURE, FetchNotificationsActionTypes.FAILURE];
const consumeUnrecoverableErrors = $action => {
  return $action.pipe(filter(action => unrecoverableErrorActionTypes.includes(action.type)), mergeMap(action => {
    return of(createUnrecoverableError(action));
  }));
};
export default combineEpics(consumeUnrecoverableErrors);